import React from 'react';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';
import {withTranslation} from 'react-i18next';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
  badgeMultiplier: {
    color: grey[500],
  },
  outer: {
    overflow: "hidden",
  },
});

const PupilBadge = ({ badge, t, classes }) => (
  <div className={`pupil-badge ${classes.outer}`}>
    <img
      src={badge.icon_url}
      alt={badge.name}
    />
    <Typography
      component="h4"
      align="center"
    >
      {badge.name}
      {badge.pupil_badges.length > 1 && (
        <Typography
          align="center"
          component="span"
          className={classes.badgeMultiplier}
        >&nbsp;
          {t(
            "x {{length}}",
            {length: badge.pupil_badges.length}
          )}
        </Typography>
      )}
    </Typography>
  </div>
);

export default withStyles(styles)(withTranslation()(PupilBadge));
